import { formatDate } from '@maia/utils';
import { Typography } from '../../../atoms/typography/typography';

type DateProps = {
  date: Date;
};

export function Date(props: DateProps) {
  const { date } = props;
  return (
    <Typography
      variant="body-xs"
      weight="regular"
      className="text-grayscale600 whitespace-nowrap"
    >
      {formatDate(date)}
    </Typography>
  );
}
